import { useState } from 'react';
/**
 * Hook to manage real-time state and controls
 * @returns Object containing real-time state and controls
 * @public
 */
export const useRealTimeState = props => {
  const {
    isRealtime
  } = props; // not mutable
  const [startRealTime, setStartRealTime] = useState(false);
  return {
    startRealTime,
    setStartRealTime,
    isRealtime
  };
};